module.exports = __webpack_public_path__ + "img/2-1.114d41bd.jpg";